(ns bleene.app.subs
  (:require
   [re-frame.core :as re-frame]))


(defn expand-path [path data params]
  (->> path
       (mapcat (fn [path-step]
                 (let [final-step (cond
                                    (and (keyword? path-step)
                                         (= (namespace path-step) "param"))
                                    (let [step-param (-> path-step name keyword)]
                                      (get params step-param))

                                    (and (keyword? path-step)
                                         (= (namespace path-step) "key"))
                                    (let [step-key (-> path-step name keyword)]
                                      (get data step-key))

                                    (or (keyword? path-step)
                                        (string? path-step))
                                    path-step)]
                   (if (coll? final-step)
                     final-step
                     [final-step]))))
       (remove nil?)
       (vec)))


(re-frame/reg-sub
 :app/query
 (fn [db [_ query-map params]]
   (->>
    (for [[key path] query-map]
      [key (reduce (fn [data step]
                     (cond
                       ;; join data from another place
                       (map? step)
                       (let [[key path] (first step)
                             ids         (get data key)
                             collection? (coll? ids)
                             full-path   (expand-path path data params)
                             join-data   (get-in db full-path)]
                         (if collection?
                           (map #(get join-data %) ids)
                           (get join-data ids)))

                       ;; special placeholder keyword to insert the param value
                       (and (keyword? step) (= (namespace step) "param"))
                       (let [step-param (-> step name keyword)
                             step-key   (get params step-param)]
                         (get data step-key))

                       ;; special placeholder keyword to insert any value from the current step
                       (and (keyword? step) (= (namespace step) "key"))
                       (let [step-key (-> step name keyword)
                             step-val (get data step-key)]
                         (if (some? step-val)
                           (get data step-val)
                           data))

                       ;; step down into key in the map
                       (or (keyword? step) (string? step))
                       (get data step)))
                   db
                   path)])
    (into {}))))
